// src/Components/Portfolio/Portfolio.jsx
import React from 'react';
import './portfolio.css';
import { Swiper, SwiperSlide } from 'swiper/react';
import Sidebar from "../../img/project_4.svg"; // Example project image
import project_1 from "../../img/project_1.svg"; // Example project image
import project_2 from "../../img/project_2.svg"; // Example project image
import project_3 from "../../img/project_3.svg"; // Example project image
import 'swiper/css';

const Portfolio = () => {
  return (
    <div className="portfolio" id='portfolio'>
      <div className="portfolio-title">
        <span>Recent Projects</span>
        <span>Portfolio</span>
      </div>

      <Swiper
        spaceBetween={30}
        slidesPerView={3}
        grabCursor={true}
        className='portfolio-Slider'
      >
        <SwiperSlide>
          <div className="portfolio-item">
            <img src={Sidebar} alt="Sidebar Project" />
            <a href="https://link-to-your-portfolio.com/project4" className="portfolio-link">View Project</a>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="portfolio-item">
            <img src={project_1} alt="Project 1" />
            <a href="https://link-to-your-portfolio.com/project1" className="portfolio-link">View Project</a>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="portfolio-item">
            <img src={project_2} alt="Project 2" />
            <a href="https://link-to-your-portfolio.com/project2" className="portfolio-link">View Project</a>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="portfolio-item">
            <img src={project_3} alt="Project 3" />
            <a href="https://link-to-your-portfolio.com/project3" className="portfolio-link">View Project</a>
          </div>
        </SwiperSlide>
      </Swiper>
    </div>
  );
}

export default Portfolio;